import en from 'date-fns/locale/en-GB'
import cs from 'date-fns/locale/cs'
import de from 'date-fns/locale/de'
import pl from 'date-fns/locale/pl'

export const dateLocales = { en, cs, de, pl }
